import { jsxs as d, Fragment as $, jsx as o } from "react/jsx-runtime";
import { Modal as P, FieldErrorAndDescription as ee, SecondaryButton as ie, PrimaryButton as re, toast as F } from "@systemeio/ui";
import { useState as f } from "react";
import { twMerge as oe } from "tailwind-merge";
import { useTranslation as te } from "../../i18n.mjs";
import { FileUploaderDropZone as ae } from "./components/file-uploader-drop-zone/index.mjs";
import { FileUploaderItem as h } from "./components/file-uploader-item/index.mjs";
import { useFileUploaderManager as le } from "./hooks/use-file-uploader-manager.mjs";
import { isOsFile as ne, isOsFileWithId as se, isFileInfoInterface as ce } from "./types/index.mjs";
import { useStateWatcher as S } from "../../utils/use-state-watcher.mjs";
import { isImageFile as j } from "../../utils/is-image.mjs";
import { ImageCropperModal as de } from "../image-cropper/image-cropper-modal.mjs";
import { getImageAspectRatio as fe, areAspectRatiosEqual as pe } from "../../utils/aspect-ratio.mjs";
import { getArrayDifference as A } from "../../utils/get-array-difference.mjs";
const De = ({
  uploaderRef: _,
  opened: L,
  source: B,
  imageCropperModalProps: s,
  showCroppingNote: M,
  acceptTypes: v,
  fileManagerApiType: W,
  actionLabel: Z,
  singleFileMode: q,
  openCroppingModalOnAdding: T,
  requireCropping: z,
  onClose: U,
  onUploadFinish: G
}) => {
  const { t } = te(), [c, w] = f(!1), [p, C] = f(), {
    waitingUploadFiles: l,
    setWaitingUploadFiles: a,
    removingFiles: H,
    mappedUploadedFiles: y,
    mappedUploadingFiles: O,
    startUploading: J,
    setUploadedFiles: K,
    deleteUploadedOrUploadingFile: I
  } = le({
    fileManagerApiType: W,
    source: B
  }), m = async (e) => {
    var N;
    const i = (N = s == null ? void 0 : s.imageCropperProps) == null ? void 0 : N.aspectRatio;
    if (!j(e) || !i || isNaN(i))
      return !0;
    const r = URL.createObjectURL(e), [n, g] = await fe(r);
    return !!pe(g, i);
  };
  S(l, async (e, i) => {
    if (!T) return;
    const { added: r } = e ? A(e, i) : { added: i };
    for (const { file: n } of r)
      if (!await m(n)) {
        k(n);
        break;
      }
  }), S(l, async (e, i) => {
    if (!M) return;
    const { added: r } = e ? A(e, i) : { added: i };
    for (const { file: n } of r)
      if (!await m(n)) {
        F(t("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
        break;
      }
  });
  const Q = async (e) => {
    a(q ? [{ file: e }] : (i) => [{ file: e }, ...i]);
  }, u = async (e) => {
    try {
      ne(e) && a((i) => i == null ? void 0 : i.filter((r) => r.file !== e)), se(e) && (await I(e.id), a((i) => i == null ? void 0 : i.filter((r) => r.file !== e.file))), ce(e) && await I(e.id);
    } catch {
      F.error(t("file_manager.error"));
    }
  }, V = async () => {
    try {
      if (C(void 0), w(!0), z) {
        for await (const { file: r } of l)
          if (!await m(r))
            throw new Error(t("file_manager.image_cropper.aspect_ratio.need_to_crop_note"));
      }
      const e = [], i = await Promise.allSettled(
        l.map(
          ({ file: r }) => J(r).catch(() => {
            e.push(t("file_manager.error") + ": " + r.name);
          })
        )
      );
      if (e.length)
        throw new Error(e.join(", "));
      await G(
        i.map((r) => {
          if (r.status === "fulfilled")
            return r.value;
        })
      ), F.success(t("file_manager.file_upload.uploaded_successfully"));
    } catch (e) {
      const i = e instanceof Error ? e : new Error(t("file_manager.error"));
      C(i);
    } finally {
      w(!1);
    }
  }, R = !![...l, ...O, ...y].length, [X, E] = f(!1), [D, b] = f(), k = (e) => {
    E(!0), b(e);
  }, x = () => {
    E(!1), b(void 0);
  }, Y = (e) => {
    a(
      (i) => i.map((r) => r.file === D ? { file: e } : r)
    ), x();
  };
  return _ && (_.current = {
    setWaitingUploadFiles: a
  }), /* @__PURE__ */ d($, { children: [
    /* @__PURE__ */ o(
      P,
      {
        title: t("file_manager.file_upload.upload_files"),
        isCentered: !0,
        isFetching: c,
        opened: L,
        onClose: U,
        afterLeave: () => {
          K([]), a([]);
        },
        children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-5", children: [
          /* @__PURE__ */ d(
            ae,
            {
              acceptTypes: v,
              onSelectFile: Q,
              dropZoneClassName: oe("min-h-[400px]", !R && "items-center"),
              label: t("file_manager.file_upload.drop_files_here"),
              disabled: c,
              children: [
                l.map((e, i) => /* @__PURE__ */ o("div", { title: e.file.name, children: /* @__PURE__ */ o(
                  h,
                  {
                    file: e.file,
                    isError: !!e.error,
                    onDeleteFile: () => u(e.file),
                    showDeleteButton: !0,
                    showEditButton: j(e.file),
                    onEdit: () => k(e.file)
                  }
                ) }, i + e.file.name)),
                O.map((e) => /* @__PURE__ */ o("div", { title: e.file.name, children: /* @__PURE__ */ o(
                  h,
                  {
                    file: e.file.file,
                    progress: e.progress,
                    isLoading: !0,
                    onDeleteFile: () => u(e.file)
                  }
                ) }, e.file.id)),
                y.map((e) => /* @__PURE__ */ o("div", { title: e.file.name, children: /* @__PURE__ */ o(
                  h,
                  {
                    file: e.file,
                    progress: e.progress,
                    isLoaded: !0,
                    isDeleting: H.includes(e.file.id),
                    onDeleteFile: () => u(e.file)
                  }
                ) }, e.file.id))
              ]
            }
          ),
          /* @__PURE__ */ o("div", { children: /* @__PURE__ */ o(
            ee,
            {
              error: p == null ? void 0 : p.message,
              className: "text-center"
            }
          ) }),
          /* @__PURE__ */ d("div", { className: "flex justify-end gap-3", children: [
            /* @__PURE__ */ o(ie, { disabled: c, onClick: () => U(), children: t("file_manager.cancel") }),
            /* @__PURE__ */ o(
              re,
              {
                isFetching: c,
                onClick: V,
                disabled: !R,
                children: Z ?? t("file_manager.upload")
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ o(
      de,
      {
        imageFile: D,
        opened: X,
        onClose: x,
        onCrop: Y,
        ...s
      }
    )
  ] });
};
export {
  De as FileUploaderModal
};
